import api from "./axios";

const ApiService = {
  
  // GET list: api.getList("prebuilt-pcs")
  getList: async (endpoint) => {
    const res = await api.get(`/${endpoint}`);
    return res.data;
  },

  // GET single: api.getById("prebuilt-pcs", 5)
  getById: async (endpoint, id) => {
    const res = await api.get(`/${endpoint}/${id}`);
    return res.data;
  },

  // POST create
  create: async (endpoint, data) => {
    const res = await api.post(`/${endpoint}`, data);
    return res.data;
  },

  // PUT update
  update: async (endpoint, id, data) => {
    const res = await api.put(`/${endpoint}/${id}`, data);
    return res.data;
  },

  // DELETE delete
  remove: async (endpoint, id) => {
    const res = await api.delete(`/${endpoint}/${id}`);
    return res.data;
  }
};

export default ApiService;
